import * as fs from 'node:fs';
import { getBridgeRoot } from '../../files/cwd/index.js';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import { applyPreTurnSnapshot, snapshotFilePath } from '../../git/snapshot/capture.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handleRevertTurnSnapshotMessage: BridgeMessageHandler<'revert_turn_snapshot'> = (msg, deps) => {
  const id = typeof msg.id === 'string' ? msg.id : '';
  const sessionId = typeof msg.sessionId === 'string' ? msg.sessionId : '';
  const turnId = typeof msg.turnId === 'string' ? msg.turnId : '';
  if (!id || !sessionId || !turnId) return;

  const { getWs, log, sessionWorktreeManager } = deps;
  void (async () => {
    const s = getWs();
    if (!s) return;
    const agentBase = sessionWorktreeManager.getSessionWorktreeRootForSession(sessionId) ?? getBridgeRoot();
    const file = snapshotFilePath(agentBase, turnId);
    try {
      await fs.promises.access(file, fs.constants.F_OK);
    } catch {
      sendWsMessage(s, {
        type: 'revert_turn_snapshot_result',
        id,
        ok: false,
        error: 'No snapshot found for this turn (git state may be unavailable).',
      });
      return;
    }
    const res = await applyPreTurnSnapshot(file, log);
    sendWsMessage(s, {
      type: 'revert_turn_snapshot_result',
      id,
      ok: res.ok,
      ...(res.error ? { error: res.error } : {}),
    });
  })();
};
